import { formatPhoneNumber } from './phone-utils';
import type { OrderAddress } from '../bff-api/baskets/model/OrderAddress';
import type { Customer } from '../bff-api/customers/model';
import type { ContactInfo } from '../pages/checkout/model/ContactInfo';

export const isValidContact = (
    contact: ContactInfo | null | undefined,
    validateNames: boolean,
): boolean => {
    if (!contact?.email || !contact.phone) {
        return false;
    }

    if (validateNames) {
        return !!(contact.firstName && contact.lastName);
    }

    return true;
};

export const toContactInfo = (
    { firstName, lastName, phone, c_email, c_signUpNewsletter }: OrderAddress,
    customer?: Customer,
): ContactInfo => ({
    firstName,
    lastName,
    phone: formatPhoneNumber(phone || customer?.addresses?.find((adr) => !!adr.phone)?.phone),
    email: c_email || customer?.email,
    signUpNewsletter: !!c_signUpNewsletter,
});

export const EMPTY_CONTACT: ContactInfo = {
    email: '',
    phone: '',
    firstName: '',
    lastName: '',
    signUpNewsletter: false,
};

export const getAuthorName = (firstName?: string | null, lastName?: string | null): string =>
    [firstName, lastName].filter(Boolean).join(' ');
